module.exports = __webpack_public_path__ + "static/media/utu_light.a458e447.svg";